<app-toast-host></app-toast-host>
@if (pwa.applyingUpdate()) {
    <section class="app-update-gate" role="alertdialog" aria-modal="true" aria-live="assertive" aria-busy="true" aria-labelledby="app-update-title" aria-describedby="app-update-description">
        <div class="app-update-gate__panel">
            <mat-icon aria-hidden="true">system_update_alt</mat-icon>
            <h1 id="app-update-title">Estamos poniendo al día la app</h1>
            <p id="app-update-description">Danos unos segundos…</p>
            <div class="app-update-gate__bar" aria-hidden="true"><span></span></div>
        </div>
    </section>
}
@if (connectivity.online()) {
    <app-navbar></app-navbar>
    <app-router></app-router>
    <app-footer></app-footer>
    <app-decision-notice-host></app-decision-notice-host>
    <app-native-reader-island></app-native-reader-island>
    <!-- Paleta Ctrl+K de escritorio: se descarga la primera vez que se pide. -->
    @defer (when commandPalette.requested()) { <app-web-command-palette></app-web-command-palette> }
    @if (pwa.canInstall()) {
        <button class="pwa-install app-touch-target" type="button" (click)="installApp()" aria-label="Instalar Memoria bibliográfica">
            <mat-icon aria-hidden="true">install_mobile</mat-icon>
            <span>Instalar</span>
        </button>
    }
    @if (!sessionReady) {
        <div class="dragon-loader" role="status" aria-live="polite" aria-label="Restaurando sesión">
            <img [src]="dragonLoader" alt="">
            <div class="dragon-loader__bar" aria-hidden="true">
                <span></span>
            </div>
            <p>{{ networkFeedback.message() || 'Recuperando tu biblioteca…' }}</p>
        </div>
    }
    @if (building) {
        <div class="dragon-loader" role="status" aria-live="polite" aria-label="Cargando">
            <img [src]="dragonLoader" alt="">
            <div class="dragon-loader__bar" aria-hidden="true">
                <span></span>
            </div>
            <p>{{ networkFeedback.message() || loaderMessage }}</p>
        </div>
    }
} @else {
    <section class="offline-gate" role="alert" aria-live="assertive" aria-labelledby="offline-title">
        <div class="offline-gate__panel">
            <mat-icon aria-hidden="true">cloud_off</mat-icon>
            <h1 id="offline-title">Estás sin conexión</h1>
            <p>La aplicación está disponible, pero tus libros y datos privados no se guardan en la caché de este dispositivo.</p>
            <p>Cuando recuperes la red podrás continuar con tu sesión y sincronizar los cambios con seguridad.</p>
            <button class="app-touch-target" type="button" (click)="retryConnection()">Volver a intentar</button>
        </div>
    </section>
}
